/**
 * @generated SignedSource<<bcbe39d209577467ce07e90cb4e6a0f7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type genericRuleEditor_MoqRuleProductCountQuery$variables = {
  id: string;
};
export type genericRuleEditor_MoqRuleProductCountQuery$data = {
  readonly moqRule: {
    readonly products: ReadonlyArray<{
      readonly productID: number;
    }>;
  };
};
export type genericRuleEditor_MoqRuleProductCountQuery = {
  response: genericRuleEditor_MoqRuleProductCountQuery$data;
  variables: genericRuleEditor_MoqRuleProductCountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "MoqRuleProduct",
  "kind": "LinkedField",
  "name": "products",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "productID",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "genericRuleEditor_MoqRuleProductCountQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "MoqRule",
        "kind": "LinkedField",
        "name": "moqRule",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "genericRuleEditor_MoqRuleProductCountQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "MoqRule",
        "kind": "LinkedField",
        "name": "moqRule",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8f95c3ee72a602785046fae5c0eedd3e",
    "id": null,
    "metadata": {},
    "name": "genericRuleEditor_MoqRuleProductCountQuery",
    "operationKind": "query",
    "text": "query genericRuleEditor_MoqRuleProductCountQuery(\n  $id: ID!\n) {\n  moqRule(id: $id) {\n    products {\n      productID\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e42ee8c19f216f8dfd26d04a06e16562";

export default node;
